import { useSelector } from "react-redux";
import { ACTION } from "src/util/utils";
import { Tooltip } from "antd";
import Button from "src/components/common/Button/Button";
import { Button as AntButton } from "antd";
import { DownSquareOutlined, ProfileOutlined, RightSquareOutlined } from "@ant-design/icons";
import useRolePermission from "src/hooks/useRolePermission";
import InventoryFinalUpdateLinks from "./InventoryFinalUpdateLinks";
import { MODULE_KEY } from "./actions";
import { formatDate } from "src/util/date";
import { useFeaturePermission } from "src/context/FeaturePermissionContext";
import { FEATURE_NAMES } from "src/util/constants/feature.constants";

export default function filterColumns(
    runValidationModal?: ((record: any) => void) | any,
    finalUpdateModal?: ((record: any) => void) | any,
) {

    const { loading, data } = useSelector(
        (state: any) => state[`${MODULE_KEY}${ACTION.STATE_KEY}`]
    );
    const { hasPermission } = useRolePermission();
    const { isReadOnly } = useFeaturePermission(FEATURE_NAMES.FinalInventoryUpdate);
    const columns = [
        {
            header: "ID",
            accessorKey: "Id",
            enableColumnFilter: true,
            enableSorting: true,
            size: 50,
        },
        {
            header: "FILE NAME",
            accessorKey: "OriginalFileName",
            enableColumnFilter: true,
            enableSorting: true,
            size: 100,
        },
        {
            header: "UPLOADED BY",
            accessorKey: "UploadedBy",
            enableColumnFilter: true,
            enableSorting: true,
            size: 100,
        },
        {
            header: "UPLOADED DATE",
            accessorKey: "UploadedDate",
            enableColumnFilter: true,
            enableSorting: true,
            size: 100,
            Cell: ({ cell }: { cell: any }) => {
                const uploadedDate = cell.row?.original.UploadedDate;
                if (!uploadedDate || uploadedDate === "null") {
                    return "N/A";
                }
                const formattedUploadedDate = formatDate(uploadedDate);
                return formattedUploadedDate;
            }
        },
        {
            header: "TOTAL ROWS",
            accessorKey: "TotalLocations",
            enableColumnFilter: true,
            enableSorting: true,
            size: 90,
        },
        {
            header: "VALIDATION RESULTS",
            accessorKey: "ValidationsFailed",
            enableColumnFilter: true,
            enableSorting: true,
            size: 90,
            Cell: ({ cell }: { cell: any }) => {
                return (
                    <InventoryFinalUpdateLinks
                        param={cell.row?.original.Id}
                        modalTitle={"Inventory Final Update Validations"}
                    />
                );
            },
        },
        {
            header: "ACTION",
            accessorKey: "operation",
            enableColumnFilter: false,
            enableSorting: false,
            size: 90,
            align: 'right',
            Cell: ({ cell }: { cell: any }) => {
                return (
                    <>
                        <div className="d-flex w-100">
                            <div>
                                <Tooltip placement="top" title="Run Validation">
                                    <Button
                                        style={{ marginLeft: "10px" }}
                                        icon={<ProfileOutlined />}
                                        onClick={() => runValidationModal(cell.row?.original.Id)}
                                        children={undefined}
                                        hidden={isReadOnly || !hasPermission("finalinventoryupdate_runvalidation")}
                                    ></Button>
                                </Tooltip>
                            </div>
                            <div>
                                <Tooltip placement="top" title="Final Update">
                                    <Button
                                        style={{ marginLeft: "10px", display: (cell.row?.original.ValidationCount > 0 && cell.row?.original.UpdateStatus === false) ? "block" : "none" }}
                                        icon={<RightSquareOutlined />}
                                        onClick={() => finalUpdateModal(cell.row?.original.Id)}
                                        children={undefined}
                                        danger={true}
                                        hidden={isReadOnly || !hasPermission("finalinventoryupdate_finalupdate")}
                                    ></Button>
                                </Tooltip>
                            </div>
                            <div>
                                <Tooltip placement="top" title="Download File">
                                    <section className="btn-wrapper">
                                        <AntButton
                                            type="link"
                                            size="small"
                                            style={{ marginLeft: "10px", background: "#003366" }}
                                            icon={<DownSquareOutlined style={{ color: "white" }} />}
                                            href={`${cell.row?.original.BlobPath}`} download>
                                        </AntButton>
                                    </section>
                                </Tooltip>
                            </div>
                        </div>
                    </>
                );
            }
        },
    ];
    return { columns, data, loading };
}